import Pagination from '@sats-group/ui-lib/react/pagination';
import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import ArrowLink from '~/client/components/arrow-link/arrow-link';
import ArticleCard from '~/client/components/article-card/article-card';
import ContentBlocks from '~/client/components/content-blocks/content-blocks';
import ContentContainer from '~/client/components/content-container/content-container';
import Layout from '~/client/components/layout/layout';
import type { Press as Props } from './press.types';

const Press: React.FC<Props> = ({
  blocks,
  body,
  entries,
  layout,
  links,
  pagination,
  title,
}) => (
  <Layout {...layout}>
    <div className="press">
      <ContentContainer theme={ContentContainer.themes.wide}>
        <div className="press__container">
          <div className="press__header">
            <div className="press__text">
              <Text
                elementName="h1"
                italic
                size={Text.sizes.headline2}
                theme={Text.themes.headline}
              >
                {title}
              </Text>
              <Text elementName="p">{body}</Text>
            </div>
            <div className="press__links">
              {links.map(entry => (
                <div key={entry.href}>
                  <ArrowLink {...entry} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </ContentContainer>
      <ContentContainer theme={ContentContainer.themes.wide}>
        <div className="press__container">
          <div className="press__entries">
            {entries.map(entry => (
              <div key={entry.href}>
                <ArticleCard {...entry} mediaRatioLock="1:1" tall />
              </div>
            ))}
          </div>
        </div>
      </ContentContainer>
      {pagination ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <div className="press__container">
            <div className="press__pagination">
              <Pagination {...pagination} navigateOnSelect />
            </div>
          </div>
        </ContentContainer>
      ) : null}
      {blocks ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <ContentBlocks {...blocks} />
        </ContentContainer>
      ) : null}
    </div>
  </Layout>
);

export default Press;
